import { ALL_BLOCK_TYPE } from '@/config/constants';

const ORDER_REQUIRED = [
    ALL_BLOCK_TYPE.BLOCK_RADIO,
    ALL_BLOCK_TYPE.BLOCK_SELECT,
    ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
    ALL_BLOCK_TYPE.BLOCK_INPUT,
    ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
    ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE,
    ALL_BLOCK_TYPE.BLOCK_DATE,
    ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
    ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE,
    ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
    ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER,
    ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY,
    ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX,
    ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION
];

const LABEL = [
    ALL_BLOCK_TYPE.BLOCK_RADIO,
    ALL_BLOCK_TYPE.BLOCK_SELECT,
    ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
    ALL_BLOCK_TYPE.BLOCK_INPUT,
    ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
    ALL_BLOCK_TYPE.BLOCK_DISPLAY_1,
    ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE,
    ALL_BLOCK_TYPE.BLOCK_DATE,
    ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
    ALL_BLOCK_TYPE.BLOCK_POSTCODE_AND_PROVINCE,
    ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE,
    ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
    ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER,
    ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY,
    ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX
];

const DISPLAY_CONFIRM = [
    ALL_BLOCK_TYPE.BLOCK_RADIO,
    ALL_BLOCK_TYPE.BLOCK_SELECT,
    ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
    ALL_BLOCK_TYPE.BLOCK_INPUT,
    ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
    ALL_BLOCK_TYPE.BLOCK_DISPLAY_1,
    ALL_BLOCK_TYPE.BLOCK_DISPLAY_2,
    ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE,
    ALL_BLOCK_TYPE.BLOCK_DATE,
    ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
    ALL_BLOCK_TYPE.BLOCK_POSTCODE_AND_PROVINCE,
    ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE,
    ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
    ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER,
    ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY,
    ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX
];

const PERSONAL_SETTINGS = [
    ALL_BLOCK_TYPE.BLOCK_RADIO,
    ALL_BLOCK_TYPE.BLOCK_SELECT,
    ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
    ALL_BLOCK_TYPE.BLOCK_INPUT,
    ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
    ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE,
    ALL_BLOCK_TYPE.BLOCK_DATE,
    ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
    ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE,
    ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
    ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER,
    ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY,
    ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX,
    ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION
];

const LAYOUT = [
    ALL_BLOCK_TYPE.BLOCK_RADIO,
    ALL_BLOCK_TYPE.BLOCK_SELECT,
    ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
    ALL_BLOCK_TYPE.BLOCK_INPUT,
    ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
    ALL_BLOCK_TYPE.BLOCK_DISPLAY_2,
    ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE,
    ALL_BLOCK_TYPE.BLOCK_DATE,
    ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
    ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE,
    ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
    ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER,
    ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY,
    ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX
];

const BACKGROUND_COLOR = [
    ALL_BLOCK_TYPE.BLOCK_RADIO,
    ALL_BLOCK_TYPE.BLOCK_SELECT,
    ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
    ALL_BLOCK_TYPE.BLOCK_INPUT,
    ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
    ALL_BLOCK_TYPE.BLOCK_DISPLAY_1,
    ALL_BLOCK_TYPE.BLOCK_DISPLAY_2,
    ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE,
    ALL_BLOCK_TYPE.BLOCK_DATE,
    ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
    ALL_BLOCK_TYPE.BLOCK_POSTCODE_AND_PROVINCE,
    ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE,
    ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
    ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER,
    ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY,
    ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX
];

const INPUT_CONDITIONS = [
    ALL_BLOCK_TYPE.BLOCK_RADIO,
    ALL_BLOCK_TYPE.BLOCK_SELECT,
    ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
    ALL_BLOCK_TYPE.BLOCK_INPUT,
    ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
    ALL_BLOCK_TYPE.BLOCK_DISPLAY_1,
    ALL_BLOCK_TYPE.BLOCK_DISPLAY_2,
    ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE,
    ALL_BLOCK_TYPE.BLOCK_DATE,
    ALL_BLOCK_TYPE.BLOCK_POSTCODE_AND_PROVINCE,
    ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
    ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE,
    ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
    ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER,
    ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY,
    ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX
];

const LABEL_TYPE_1 = [
    ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
    ALL_BLOCK_TYPE.BLOCK_INPUT,
    ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX,
    ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION
];
const LABEL_TYPE_2 = [ALL_BLOCK_TYPE.BLOCK_FULL_NAME];

const VISIABLE_FILED_SERIAL_CODE_SETBLOCK = ['prize_Lottery', 'prize_rejection'];

export {
    ORDER_REQUIRED,
    LABEL,
    DISPLAY_CONFIRM,
    PERSONAL_SETTINGS,
    LAYOUT,
    BACKGROUND_COLOR,
    INPUT_CONDITIONS,
    LABEL_TYPE_1,
    LABEL_TYPE_2,
    VISIABLE_FILED_SERIAL_CODE_SETBLOCK
};
